import { Component, OnInit } from '@angular/core';

import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { Store } from '@ngxs/store';
import { AuctionService, LaunchDarklyService } from 'remarketing-angular-library';

@Component({
  selector: 'app-make-hold-modal',
  imports: [TranslocoDirective],
  templateUrl: './make-hold-modal.component.html',
  styleUrl: './make-hold-modal.component.scss'
})
export class MakeHoldModalComponent extends ChangeStatusModalDirective implements OnInit {

  private textHoldVehicles: string;
  private textHoldVehicle: string;
  private textSelectingVehicles: string;
  private textSelectingVehicle: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textHoldVehicles;
    } else {
      return this.textHoldVehicle;
    }
  }

  get modalBody() {
    if (this.selectedVehicles.length > 1) {
      return this.textSelectingVehicles;
    } else {
      return this.textSelectingVehicle;
    }
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.makeHoldModal')
      .subscribe(translate => {
        this.textHoldVehicles = translate.textHoldVehicles;
        this.textHoldVehicle = translate.textHoldVehicle;
        this.textSelectingVehicles = translate.textSelectingVehicles;
        this.textSelectingVehicle = translate.textSelectingVehicle;
      });
  }
}
